import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';

export const COLUMNS = [
    {
        label: 'Date',
        key: 'created_date',
        data: 'created_date',
        Component: Cell,
        renderCell: ({ data }) => (data ? moment(data).format('MMM Do YY') : '-'),
    },
    {
        label: 'Invoice Number',
        key: 'id',
        data: 'id',
        Component: Cell,
    },
    {
        label: 'Status',
        key: 'status',
        data: 'status',
        Component: Cell,
        renderCell: ({ data }) => (
            <div className={`invoices-status ${data?.toLowerCase() === 'paid' ? 'active' : ''}`}>
                {data}
            </div>
        ),
    },
    {
        label: 'Description',
        key: 'description',
        data: 'description',
        Component: Cell,
    },
    {
        label: 'Payment',
        key: 'amount_paid',
        data: 'amount_paid',
        Component: Cell,
    },
    {
        label: 'Message',
        key: 'message',
        data: 'message',
        Component: Cell,
    },
    {
        label: 'Actions',
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item }) => {
            return (
                <div>
                    <a
                        className="btn"
                        rel="noreferrer"
                        href={item.url_pdf}
                        role="button"
                        target="_blank"
                        download
                    >
                        <i className="icofont-download" style={{ color: '#98A2B3' }}></i>
                    </a>
                    <a
                        className="btn"
                        rel="noreferrer"
                        href={`mailto:${item.mail}?subject=Invoice&body=${item.url_pdf}`}
                        role="button"
                    >
                        <i className="icofont-envelope" style={{ color: '#98A2B3' }}></i>
                    </a>
                </div>
            );
        },
    },
];
